import React, { useEffect, useState } from 'react'

interface Props {
  svgUrl: string // L'URL de l'image SVG
  fillColor?: string // La couleur finale souhaitée
  height?: string // La hauteur de l'image
}

const SvgColorChanger: React.FC<Props> = ({ svgUrl, fillColor, height }) => {
  const [modifiedSvg, setModifiedSvg] = useState<string | null>(null)

  useEffect(() => {
    // Fonction pour charger et modifier le contenu SVG
    const loadAndModifySvg = async () => {
      try {
        // Récupérez le contenu SVG via Fetch
        const response = await fetch(svgUrl)
        const svgContent = await response.text()
        // Modifiez le contenu SVG pour changer la couleur et la taille
        // Remove xml tag that can appear at the beginning of the data
        let modifiedSvgContent = svgContent.replace(/<!--[^>]+-->/g, '')
        // Remove comments that can appear inside the data
        modifiedSvgContent = modifiedSvgContent.replace(/<\?xml[^>]+>/g, '')
        if (fillColor) {
          if (modifiedSvgContent.indexOf('fill=') === -1) {
            // Add "fill" property to the svg if it does not exist and a fillColor was given
            const firstSvgClosing = modifiedSvgContent.indexOf('>')
            if (firstSvgClosing) {
              // Get the first svg tag, add "fill=<fillColor>" inside and replace the content of the svg
              const tempFirstSvgTag = modifiedSvgContent.substring(
                0,
                firstSvgClosing
              )

              modifiedSvgContent = modifiedSvgContent.replace(
                modifiedSvgContent.substring(0, firstSvgClosing),
                `${tempFirstSvgTag} fill="${fillColor}"`
              )
            }
          } else {
            modifiedSvgContent = modifiedSvgContent
              .replace(/fill="#[A-Fa-f0-9]+"/g, `fill="${fillColor}"`)
              .replace(/fill='#[A-Fa-f0-9]+'/g, `fill='${fillColor}'`)
          }

          // Change the "stroke" data with the chosen color
          modifiedSvgContent = modifiedSvgContent.replace(
            /stroke:[^;]+;/g,
            `stroke: ${fillColor};`
          )
        }
        if (height) {
          // Remove width and change height by the one wanted in the first tag of the svg
          const firstSvgClosing = modifiedSvgContent.indexOf('>')
          if (firstSvgClosing) {
            let tempFirstSvgTag = modifiedSvgContent
              .substring(0, firstSvgClosing)
              .replace(/width="[^"]+"/, '')
              .replace(/height="[^"]+"/, `height="${height}"`)

            // Add "height" property if not present in the tag
            tempFirstSvgTag.indexOf('height') === -1 &&
              (tempFirstSvgTag = `${tempFirstSvgTag} height="${height}"`)

            modifiedSvgContent = modifiedSvgContent.replace(
              modifiedSvgContent.substring(0, firstSvgClosing),
              tempFirstSvgTag
            )
          }
        }

        // Mettez à jour l'état avec le SVG modifié
        setModifiedSvg(modifiedSvgContent)
      } catch (error) {
        console.error(
          "Une erreur s'est produite lors de la récupération du SVG :",
          error
        )
      }
    }

    // Chargez et modifiez le SVG lorsque le composant est monté
    loadAndModifySvg()
  }, [svgUrl, fillColor])

  return (
    <>
      {modifiedSvg && (
        <div
          style={{
            height: height || '100%'
          }}
          dangerouslySetInnerHTML={{ __html: modifiedSvg }}
        />
      )}
    </>
  )
}

export default SvgColorChanger
